import { DataRoomClientFile } from '@/common/types';

export interface FileInstance {
  file: DataRoomClientFile;
  folderPath: string;
  instanceId: string; // Unique identifier: fileId + folderPath
}

export const createFileInstanceId = (fileId: string, folderPath: string): string => {
  return `${fileId}:${folderPath}`;
};
